import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Card, Form, Input, Button, Typography, Alert, Spin, Modal, Space  } from "antd";
import { LockOutlined, MailOutlined, AndroidOutlined, AppleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { useSetMemberPasswordMutation, useVerifyMemberTokenMutation } from "./setMemberPassword.service";
import { toast } from "react-toastify";
import "./style.css";
import { BACKEND_URL } from "../../constant";

const { Title, Text } = Typography;

const SetMemberPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  
  const [token, setToken] = useState("");
  const [email, setEmail] = useState("");
  const [isValidating, setIsValidating] = useState(true);
  const [isValidToken, setIsValidToken] = useState(false);

  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [userEmail, setUserEmail] = useState("");

  const [verifyToken, { isLoading: isVerifying }] = useVerifyMemberTokenMutation();
  const [setPassword, { isLoading: isSettingPassword }] = useSetMemberPasswordMutation();

  useEffect(() => {
    const tokenParam = searchParams.get("token");
    const emailParam = searchParams.get("email");

    if (!tokenParam || !emailParam) {
      toast.error("Invalid invitation link");
      navigate("/");
      return;
    }

    setToken(tokenParam);
    setEmail(decodeURIComponent(emailParam));

    // Verify token
verifyToken({ 
  token: tokenParam, 
  email: decodeURIComponent(emailParam) 
})
  .unwrap()
  .then((response) => {
    // Check-email response handle karo
    if (response.data?.passwordSet) {
      toast.error("Password already set");
      setTimeout(() => navigate("/"), 3000);
    } else {
      setIsValidToken(true);
    }
  })
  .catch((error) => {
    toast.error(error.data?.message || "Invalid or expired invitation");
    setTimeout(() => navigate("/"), 3000);
  })
  .finally(() => {
    setIsValidating(false);
  });
  }, [searchParams, navigate, verifyToken]);

  const handleSubmit = async (values) => {
    if (values.password !== values.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      await setPassword({
        token,
        email,
        password: values.password,
      }).unwrap();

      toast.success("Password set successfully! You can now log in.");
         setShowSuccessDialog(true);
    } catch (error) {
      toast.error(error.data?.message || "Failed to set password");
    }
  };

  if (isValidating || isVerifying) {
    return (
      <div className="set-password-container">
        <Card className="set-password-card">
          <div style={{ textAlign: "center", padding: "40px" }}>
            <Spin size="large" />
            <Text style={{ display: "block", marginTop: "20px" }}>
              Validating your invitation...
            </Text>
          </div>
        </Card>
      </div>
    );
  }

  if (!isValidToken) {
    return (
      <div className="set-password-container">
        <Card className="set-password-card">
          <Alert
            message="Invalid Invitation"
            description="This invitation link is invalid or has expired. Please contact your administrator."
            type="error"
            showIcon
          />
          <Button 
            type="primary" 
            onClick={() => navigate("/")}
            style={{ marginTop: "20px", width: "100%" }}
          >
            Go to Home
          </Button>
        </Card>
      </div>
    );
  }

    // 👇 YEH POORA DIALOG COMPONENT ADD KARO (return statement se PEHLE)
  const SuccessDialog = () => (
    <Modal
      open={showSuccessDialog}
      onCancel={() => {
        setShowSuccessDialog(false);
        window.location.href = "${BACKEND_URL}/login";
      }}
      footer={null}
      width={380}
      centered
      closable={false}
    >
      <div style={{ textAlign: "center", padding: "20px 10px" }}>
        {/* Success Icon */}
        <div style={{ 
          width: "70px", 
          height: "70px", 
          background: "#52c41a20", 
          borderRadius: "50%", 
          margin: "0 auto 15px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}>
          <CheckCircleOutlined style={{ fontSize: "40px", color: "#52c41a" }} />
        </div>

        <Title level={4} style={{ margin: "0 0 5px", color: "#2d5a3d" }}>
          Ready to Go! 🎉
        </Title>
        
        <Text style={{ fontSize: "14px", color: "#666", display: "block", marginBottom: "20px" }}>
          Your password is set. Download the app to start.
        </Text>

        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          {/* Android Button */}
          <Button
            href="https://play.google.com/store/apps/details?id=com.sfbbpro.app"
            target="_blank"
            icon={<AndroidOutlined />}
            size="large"
            style={{ 
              width: "100%", 
              height: "48px",
              background: "#3ddc84", 
              border: "none",
              color: "white",
              fontWeight: "bold",
              borderRadius: "8px",
              fontSize: "16px"
            }}
          >
            Google Play Store
          </Button>

          {/* iOS Button */}
          <Button
            href="https://apps.apple.com/gb/app/sfbb-pro/id6749208075"
            target="_blank"
            icon={<AppleOutlined />}
            size="large"
            style={{ 
              width: "100%", 
              height: "48px",
              background: "#000", 
              border: "none",
              color: "white",
              fontWeight: "bold",
              borderRadius: "8px",
              fontSize: "16px"
            }}
          >
            Apple App Store
          </Button>

          {/* Login Link */}
          <Button 
            type="link" 
            onClick={() => {
              setShowSuccessDialog(false);
              window.location.href = "${BACKEND_URL}/login"
            }}
            style={{ marginTop: "5px", color: "#2d5a3d" }}
          >
            Already have the app? Login here →
          </Button>
        </Space>

        <Text type="secondary" style={{ fontSize: "11px", display: "block", marginTop: "15px" }}>
          Use {userEmail} to log in
        </Text>
      </div>
    </Modal>
  );


  return (
        <>
    <div className="set-password-container">
      <Card className="set-password-card">
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
          <img 
            src="/mark1.jpg" 
            alt="SFBB Pro" 
            style={{ height: "50px", marginBottom: "20px" }}
          />
          <Title level={3} style={{ color: "#2d5a3d", margin: 0 }}>
            Set Your Password
          </Title>
          <Text type="secondary">
            You've been invited to join. Please set your password to continue.
          </Text>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          autoComplete="off"
        >
          <Form.Item
            name="email"
            label="Email Address"
            initialValue={email}
          >
            <Input 
              prefix={<MailOutlined />} 
              disabled 
              style={{ backgroundColor: "#f5f5f5" }}
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            rules={[
              { required: true, message: "Please enter your password" },
              { min: 8, message: "Password must be at least 8 characters" },
            ]}
          >
            <Input.Password 
              prefix={<LockOutlined />} 
              placeholder="Enter your password"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label="Confirm Password"
            rules={[
              { required: true, message: "Please confirm your password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords do not match"));
                },
              }),
            ]}
          >
            <Input.Password 
              prefix={<LockOutlined />} 
              placeholder="Confirm your password"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={isSettingPassword}
              size="large"
              block
              style={{
                backgroundColor: "#47e147",
                borderColor: "#47e147",
                height: "45px",
                fontSize: "16px",
              }}
            >
              Set Password & Continue
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Text type="secondary" style={{ fontSize: "12px" }}>
            This link will expire in 24 hours.
          </Text>
        </div>
      </Card>
    </div>
          <SuccessDialog />
    </>
  );
};

export default SetMemberPassword;